import i18n from '../i18n'
import { normalizeCurrency } from '../Library/Tools/CurrencyConverter'
import LocalStorage from '../Services/LocalStorage'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ems.tecnelmc.cloud:3030'
// const API_BASE_URL = 'https://209.227.237.153:3030'
// const API_BASE_URL = 'http://localhost:3030'
// const API_BASE_ADDR = 'https://ems.tecnelmc.com'

const Config = {
  STORAGE_KEY: 'EMSTECNEL',
  API_BASE_URL,
  apiUrl: API_BASE_URL, // Alias per compatibilità con i componenti
  appVersion: require('../../package.json').version,
  format
}

function format (value) {
  const numericValue = value === null || value === undefined || value === '' ? 0 : parseFloat(value)
  if (isNaN(numericValue)) return value
  const currency = normalizeCurrency(LocalStorage.get('user')?.azienda?.valuta, 'EUR')
  try {
    return new Intl.NumberFormat(i18n.language || 'it', {
      style: 'currency', currency,
      minimumFractionDigits: currency === 'XOF' ? 0 : 2,
      maximumFractionDigits: currency === 'XOF' ? 0 : 2
    }).format(numericValue)
  } catch (error) {
    return `${new Intl.NumberFormat(i18n.language || 'it', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(numericValue)} ${currency}`
  }
}

export default Config
